<template>
  <div id="testimonial">
    <flickity
      class="carousel flickity"
      ref="flickity"
      :options="flickityOptions"
      data-flickity
    >
      <div
        class="carousel-cell"
        v-for="(testimContent, index) in testimContent"
        :key="index"
      >
        <figure class="testimonial-card">
          <div class="quote1"></div>
          <div class="line1"></div>
          <figcaption>
            <blockquote>
              <p>{{ $t(testimContent.quote) }}</p>
            </blockquote>
            <h3>{{ $t(testimContent.author) }}</h3>
            <div class="line2"></div>
            <div class="quote2"></div>
          </figcaption>
        </figure>
      </div>
    </flickity>
  </div>
</template>

<script>
import Flickity from "vue-flickity";
import slides from "@/assets/resources/testim-quotes.js";

export default {
  components: {
    Flickity,
  },
  data() {
    return {
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
      },
      testimContent: slides,
    };
  },
};
</script>

<style lang="scss">
.flickity-page-dots {
  bottom: -2vh;
}
/* white circles */
.flickity-page-dots .dot {
  width: calc(12px + (30 - 12) * ((100vw - 1024px) / (3840 - 1024)));;
  height: calc(12px + (30 - 12) * ((100vw - 1024px) / (3840 - 1024)));;
  opacity: 1;
  background: transparent;
  border: 3px solid white;
}
/* fill-in selected dot */
.flickity-page-dots .dot.is-selected {
  background: white;
}

p {
  color: white;
  font-size: calc(20px + (34 - 20) * ((100vw - 1024px) / (3840 - 1024)));;
  font-family: Acumin Variable Concept, Light;
}

.line1 {
  position: absolute;
  width: 60%;
  height: 0.2vh;
  background-color: #edf6fb;
  left: 5vh;
}

.line2 {
  position: absolute;
  width: 60%;
  height: 0.2vh;
  background-color: #edf6fb;
  bottom: 2vh;
  right: 0vh;
}

.quote1 {
  position: absolute;
  background-image: url("../../assets/images/quote.svg");
  transform: rotate(180deg);
  height: 50px;
  width: 65px;
  z-index: 1;
  left: -5vh;
  top: 1vh;
}

.quote2 {
  position: absolute;
  height: 50px;
  width: 65px;
  background-image: url("../../assets/images/quote.svg");
  right: -10vh;
  bottom: 2vh;
  z-index: 1;
}

#testimonial {
  padding-top: 10vh;
  text-align: center;
  background-color: #0d2a4c;
  padding-bottom: 5vh;
}

.carousel-cell {
  width: 100%; /* full width */
  max-height: 80vh; /* height of carousel */
  display: flex;
  align-items: center;
  justify-content: center;
}

p {
  align-self: center;
  vertical-align: middle;
}

h3 {
  font-family: "Acumin Variable Concept";
}
.testimonial-card {
  // box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
  display: inline-block;
  font-size: 30px;
  max-width: 500px;
  min-width: 75%;
  position: relative;
  text-align: center;
  width: 100%;
  background-color: #0d2a4c;
}

.testimonial-card *,
.testimonial-card *:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all 0.1s ease-out;
  transition: all 0.1s ease-out;
  margin-top: 20px;
}

.testimonial-card figcaption {
  padding: 4% 8% 8%;
}

.testimonial-card h3 {
  color: #ffffff;
  font-size: 2vh;
  font-weight: bold;
  line-height: 24px;
  margin-right: -80%;
}

// .testimonial-card h4 {
//   font-weight: 400;
//   margin: 0;
//   opacity: 0.5;
// }

.testimonial-card blockquote {
  font-weight: 300;
  margin: 0 0 20px;
  height: 200px;
  overflow: hidden;
  color: #ffffff;
}

@media (max-width: 900px) {
  .flickity-page-dots {
  bottom: 1vh;
}
.flickity-page-dots .dot {
  width: 3.5vw;
  height: 3.5vw;
  opacity: 1;
  background: transparent;
  border: 2px solid white;
}
    .carousel-cell {
    flex-wrap: wrap;
    max-height: none;
  }
  figure.testimonial-card {
    margin: 10% 1%;
    height: 500px;
    width: 100%;
  }

  #testimonial {
    height: 500px;
  }

  .quote1,
  .quote2 {
    background-size: 2.5vh, 2.5vh;
  }

  .quote1 {
    top: -7vh;
  }
  .quote2 {
    bottom: -1vh;
    right: -5vh;
  }

  .line1 {
    left: 14vw;
    width: 72%;
  }

  .line2 {
    right: 14vw;
    bottom: 6vh;
    width: 72%;
  }

  .testimonial-card h3 {
    margin-right: 0vh;
  }

  .testimonial-card blockquote {
    height: 350px;
  }

  p {
    font-size: 2.5vh;
  }
}
</style>
